import createIcon from '../../createIcon';

/**
 * @component @name Lock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOC41SDE3VjYuNUMxNyAzLjc0IDE0Ljc2IDEuNSAxMiAxLjVDOS4yNCAxLjUgNyAzLjc0IDcgNi41VjguNUg2QzQuOSA4LjUgNCA5LjQgNCAxMC41VjIwLjVDNCAyMS42IDQuOSAyMi41IDYgMjIuNUgxOEMxOS4xIDIyLjUgMjAgMjEuNiAyMCAyMC41VjEwLjVDMjAgOS40IDE5LjEgOC41IDE4IDguNVpNMTIgMTcuNUMxMC45IDE3LjUgMTAgMTYuNiAxMCAxNS41QzEwIDE0LjQgMTAuOSAxMy41IDEyIDEzLjVDMTMuMSAxMy41IDE0IDE0LjQgMTQgMTUuNUMxNCAxNi42IDEzLjEgMTcuNSAxMiAxNy41Wk0xNS4xIDguNUg4LjlWNi41QzguOSA0Ljc5IDEwLjI5IDMuNCAxMiAzLjRDMTMuNzEgMy40IDE1LjEgNC43OSAxNS4xIDYuNVY4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Lock = createIcon('Lock', [
  [
    'path',
    {
      d: 'M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM12 17.5C10.9 17.5 10 16.6 10 15.5C10 14.4 10.9 13.5 12 13.5C13.1 13.5 14 14.4 14 15.5C14 16.6 13.1 17.5 12 17.5ZM15.1 8.5H8.9V6.5C8.9 4.79 10.29 3.4 12 3.4C13.71 3.4 15.1 4.79 15.1 6.5V8.5Z',
      key: '5o7paf',
    },
  ],
]);

export default Lock;
